import { PageContent } from 'components/layout/PageContent'
import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import React, { Dispatch } from 'react'

import { AtendimentoFooter } from '../AtendimentoFooter'

interface FolhaRostoViewProps {
  atendimentoId: ID
  tipoAtendimentoProfissional?: TipoAtendimentoProfissional
  clearCache: Dispatch<void>
}

export function FolhaRostoView(props: FolhaRostoViewProps) {
  return (
    <>
      <PageContent fluid type='filled'>
        Folha de Rosto
      </PageContent>
      <AtendimentoFooter
        atendimentoId={props.atendimentoId}
        tipoAtendimentoProfissional={props.tipoAtendimentoProfissional}
        clearCache={props.clearCache}
      />
    </>
  )
}
